export default __webpack_public_path__ + "static/media/landing-md.9ce8900c.jpg";